export default __webpack_public_path__ + "static/media/twitter1.d04ab61a.svg";